import React, { Component } from "react";
import {
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
    Alert
  } from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import { fetchPerformanceRequest, createPerformanceRequest, editPerformanceRequest } from "../../../api/performance";

class PerformanceForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      resource: {
        level: '',
        result: '',
        conversion: '',
        error: null
      }
    }
  }

  componentDidMount() {
    const { instanceId } = this.props;

    if (instanceId) {
      this.fetchInstance(instanceId);
    } 
  }

  fetchInstance = (id) => {
      fetchPerformanceRequest(id,
          result => this.setState(prevState => ({
              resource: {
                  ...prevState.resource,
                  ...result
              }
          })), error => this.setState({ error: 'There was an error' }));
  }

  handleFormChange = (e) => {
    const { target } = e;
    const { name, value } = target;

    this.setState(prevState => ({
      resource: {
        ...prevState.resource,
        [name]: value,
      },
    }))
  }

  save = () => {
    const {
      level,
      result,
      conversion
    } = this.state.resource;

    const {
      instanceId
    } = this.props;

    const isNewRecord = !instanceId;

    let data = {
      level,
      result,
      conversion
    };

    if (isNewRecord) {
        createPerformanceRequest(data,
            result => this.saveSuccess(),
            error => this.saveFailure(error)
        );
    } else {
        editPerformanceRequest(instanceId, data,
            result => this.saveSuccess(),
            error => this.saveFailure(error)
        );
    }
  }

  saveSuccess = () => {
    this.setState({ error: null });
    this.props.goToList('performance');
  }

  saveFailure = (error) => {
      this.setState({ error: error.message || 'There was an error saving Performance.' })
  }

  render() {

    const {
      level,
      result,
      conversion
    } = this.state.resource;

    const { error } = this.state;

    const {
      instanceId
    } = this.props;

    const isNewRecord = !instanceId;

    return (
      <Row>
        <Col md={12}>
          <Card
            title={isNewRecord ? "New entry" : "Edit entry"}
            content={
              <form>
                <Button className="card-top-btn btn-primary" onClick={() => this.props.goToList('performance')}>
                  Back to List
                </Button>
                <FormGroup>
                  <ControlLabel>Level</ControlLabel>
                  <FormControl 
                      onChange={this.handleFormChange}
                      componentClass="select" 
                      name="level"
                      value={level}
                    >
                    <option value="">Select</option>
                  </FormControl>
                </FormGroup>
                <FormGroup>
                  <ControlLabel>Result</ControlLabel>
                  <FormControl 
                      onChange={this.handleFormChange}
                      componentClass="select" 
                      name="result"
                      value={result}
                    >
                    <option value="">Select</option>
                  </FormControl>
                </FormGroup>
                <FormGroup>
                  <ControlLabel>Conversion</ControlLabel>
                  <FormControl 
                      onChange={this.handleFormChange}
                      componentClass="select" 
                      name="conversion"
                      value={conversion}
                    >
                    <option value="">Select</option>
                  </FormControl>
                </FormGroup>
                {error &&
                    <Alert bsStyle="danger">
                      {error}
                    </Alert>
                  }
                <Button bsStyle="primary" pullRight fill onClick={this.save}>
                  {isNewRecord ? "Create" : "Save changes"}
                </Button>
                <div className="clearfix" />
              </form>
            }
          />
        </Col>
      </Row>
    )
  }
}

export default PerformanceForm;
